import { useMutation } from "react-query";
import {
  createPolicyAgent,
  preCreatePolicyPaymentAgents,
} from "./create-micelu-service";
import { IUseCreatePolicyAgents } from "./use-create-micelu.interface";

export const useCreatePolicyAgents = () => {
  return useMutation((data: IUseCreatePolicyAgents) => createPolicyAgent(data));
};

export const usePreCreatePolicyPaymentAgents = () => {
  return useMutation((data: IUseCreatePolicyAgents) =>
    preCreatePolicyPaymentAgents(data),
  );
};
